import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from './Sidebar';

/* ===========================================================================
 * AdminLayout — configura o componente genérico <Sidebar> pro painel ADM.
 * ========================================================================= */

const NAV_ITEMS = [
  { to: '/admin', icon: 'fa-gauge', label: 'Dashboard', end: true },
  { to: '/admin/users', icon: 'fa-users', label: 'Usuários' },
  { to: '/admin/sales', icon: 'fa-shopping-cart', label: 'Vendas' },
  { to: '/admin/codes', icon: 'fa-qrcode', label: 'Códigos' },
  { to: '/admin/reports', icon: 'fa-chart-bar', label: 'Relatórios' },
  { to: '/admin/audit-logs', icon: 'fa-clipboard-list', label: 'Registro de Auditoria' },
  { to: '/admin/shopify', icon: 'fa-shopify', iconLib: 'fab', label: 'Integrações Shopify' },
  { to: '/admin/checkouts', icon: 'fa-plug', label: 'Checkouts' },
  { to: '/admin/settings', icon: 'fa-cog', label: 'Configurações' },
];

const AdminLayout = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const exitButton = (
    <button className="sb-topbar-credits" onClick={() => navigate('/dashboard')} title="Voltar ao painel do cliente">
      <i className="fas fa-right-from-bracket"></i>
    </button>
  );

  return (
    <Sidebar
      brandIcon="fa-shield-alt"
      brandText="Painel ADM"
      topbarBrand="ADM"
      navItems={NAV_ITEMS}
      topbarExtra={exitButton}
      footerButtons={[{ icon: 'fa-arrow-left', label: 'Voltar ao painel do cliente', onClick: () => navigate('/dashboard') }]}
      onLogout={() => { logout(); navigate('/login'); }}
    />
  );
};

export default AdminLayout;
